import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse,Drawer, Radio,Checkbox,label,Input,Popover,Select, Button ,Tooltip,TimePicker,Affix,Timeline,Modal   } from 'antd';
import Datetime from "react-datetime";
import Moment from 'moment';
import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import left from '../../assets/images/icon/next.png';
import right from '../../assets/images/icon/return.png';
import person from '../../assets/images/icon/person.png';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

const now = new Date();
var yesterday = Datetime.moment().subtract(1, "day");

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}
const item_name = [];

const format = 'HH:mm a' ;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
	  super(props);

    var date, TimeType, hour, minutes, seconds, fullTime;
    date = new Date();
    hour = date.getHours();
    if(hour <= 11){TimeType = 'am';} else{ TimeType = 'pm';}
	//alert(TimeType);
    if( hour > 12 ){hour = hour - 12;}
    if( hour == 0 ){hour = 12;  }
    minutes = date.getMinutes();
     if(minutes < 10) { minutes = '0' + minutes.toString();}
     seconds = date.getSeconds();
     if(seconds < 10){seconds = '0' + seconds.toString();}
     this.time= hour.toString() + ':' + minutes.toString() + ' ' + TimeType.toString();





		this.state = {
			size: 'default',
			item_name: item_name,
			value: '',
			student: [],
			checkedList: defaultCheckedList,
			indeterminate: true,
			checkAll: false,
			today: '',
			school_list: [],
			currentDateTime: Date().toLocaleString(),
			add : 0,
			selectedDate: null,
			total_student: 0,
			total_in: 0,
			total_out: 0,
			total_absent: 0,
			total_leave: 0,
			total_unmark: 0,
			student_absent: 0,
			student_leave: 0,
			student_unmark: 0,
			total_halfday: 0,
			selected_time:  this.time,
			program_list:[],
			checkedBoxes: [],
			division_list: [],
			attendance_type:'',
			division:'',
			timeline_details:[],
			checked: false,
			timeline: false,
			addfollow: false,

		}
		this.onChangechecked = this.onChangechecked.bind(this);
		this.nextdate = this.nextdate.bind(this);
		this.onChangeTime = this.onChangeTime.bind(this);
		this.onChangeTimeMobile = this.onChangeTimeMobile.bind(this);
	}

	

	 openQuantity(e){
		this.setState({ attendance_type: e });
		setTimeout(() => {
			this.checkData();
		}, 100);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{


		var date = new Date();
		var  currentDate =
			 date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({
			user_id : storedArray['data'][0]['user_id'],
			school_id : storedArray['data'][0]['school_id'],
			currentDate : currentDate,
		});

		this.setDate();
		this.CurrentTime();
		this.checkData();
		
		}
		
	}

	setDate = (newDate) => {
		const date = newDate || new Date();
		this.setState({
		  selectedDate:
			 date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
		});

	};

	getPreviousDate = () => {
    const { selectedDate } = this.state

    const currentDayInMilli = new Date(selectedDate).getTime()
    const oneDay = 1000 * 60 *60 *24
    const previousDayInMilli = currentDayInMilli - oneDay
    const previousDate = new Date(previousDayInMilli)
	//console.log(this.state.currentDate);
	//console.log(selectedDate);
    this.setDate(previousDate);
	setTimeout(() => {
			this.checkData();
		}, 50);
	}

	getNextDate = () => {
    const { selectedDate } = this.state

    const currentDayInMilli = new Date(selectedDate).getTime()
    const oneDay = 1000 * 60 *60 *24
    const nextDayInMilli = currentDayInMilli + oneDay
    const nextDate = new Date(nextDayInMilli)



	this.setDate(nextDate);
	setTimeout(() => {
			this.checkData();
		}, 50);
	}

	checkData(){
  	    if(localStorage.getItem('schoolData')){

			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({
			 user_id : storedArray['data'][0]['user_id'],
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];

			var date = this.state.selectedDate;
			if(date==null){
			date = new Date();
			}

			var app = {user_id : user_id,date : date,school_id:school_id}

			getData('erp/staff_attendance_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						const count = result['data']
						const lenght_ = count.length;
						this.setState({
							school_list: result['data'],
							total_student: result['total_student'],
							total_in: result['total_in'],
							total_out: result['total_out'],
							total_absent: result['total_absent'],
							total_leave: result['total_leave'],
							total_unmark: result['total_unmark'],
							total_halfday: result['total_halfday'],
						});
						if(lenght_ > 0){
							this.setState({
										student_in: result['data'][0]['student_in'],
										student_out: result['data'][0]['student_out'],
										student_absent: result['data'][0]['student_absent'],
										student_leave: result['data'][0]['student_leave'],
										student_unmark: result['data'][0]['student_unmark'],
										student_halfday: result['data'][0]['student_halfday'],

									});
						}
					}else{
						this.setState({
							school_list: [],
						});
					}
				}
			});
	}
	}

	nextdate(){
		var add = this.state.add + 1
		var today = new Date(),
		date = today.getDate()+add+ '-' + (today.getMonth() + 1) + '-' + today.getFullYear();
		this.setState({
			current_date : date,
			add : add,

		});
	}

  

	onChangechecked(checkedValues) {
	  this.setState({ student: checkedValues });
	  this.checkData();
	}

	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };

	onChange = checkedList => {
		this.setState({
		  checkedList,
		  indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
		  checkAll: checkedList.length === plainOptions.length,
		});
	};

	onChangeTime(time, timeString) {
		  this.setState({ selected_time: timeString });
	}

	onChangeTimeMobile(e) {
		  this.setState({ selected_time: e.target.value });
	}


	CurrentTime() {
                var date = new Date();
                var hours = date.getHours();
                var minutes = date.getMinutes();


                var newformat = hours >= 12 ? 'PM' : 'AM';


                hours = hours % 12;


                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;

				var time = hours + ':' + minutes + ' ' + newformat
				//alert(time);
                //document.getElementById("current_time").value = time ;
    }

	


  
	
	
	
	
	


	render()

	{
	const lenght = this.state.checkedBoxes.length;
	const student_lenght = this.state.school_list.length;
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>

					  </div>
					);
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Staff Attendance
								
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item">Staff Attendance </li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div id="main" class="bg-off" style={{'min-height': '550px'}}>
			 <div class="">


			<div class="desktop-view">
			 <div class="col-md-12 m12 no-padd">
				


			<div id="attendance" class="bg-off">
				<div class="card">
				<div class="card-body">
					<div class="col-md-12 mt-10">

						<div class="col-md-12 no-padd">
						<div class="row">
						<div class="col-md-3  s6 center no-padd">
							<div class="iq-card date_range form-group">
								<svg onClick={this.getPreviousDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(70,70,70,1)"/></svg>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2zm11 9H4v9h16v-9zm-4.964 1.136l1.414 1.414-4.95 4.95-3.536-3.536L9.38 12.55l2.121 2.122 3.536-3.536zM7 5H4v3h16V5h-3v1h-2V5H9v1H7V5z" fill="rgba(70,70,70,1)"/></svg>
								{Moment(this.state.selectedDate).format('DD-MM-YYYY')}
								{(() => {
									if (this.state.selectedDate < this.state.currentDate) {
										return (
											<svg onClick={this.getNextDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(70,70,70,1)"/></svg>
										)
									}
								})()}
							</div>

						</div>
						</div>
						</div>

					</div>
				</div>
				</div>
			</div>
			</div>
			<div class="col-md-12 m12 no-padd">
            <div class="container ">
			   <div class="col-md-12 m12 mb-20 card-content iq-card atend ">

			   <div class="col-md-12 mt-10 s12 center no-padd">
						<p class="atn-label bg-white color-1 br-left10">Total<span>{this.state.total_student}</span></p>
						<p class="atn-label bg-white in-color">Present<span>{this.state.total_in}</span></p>
						<p class="atn-label bg-white out-color hidden">Out<span>{this.state.total_out}</span></p>
						<p class="atn-label bg-white halfday-color">Halfday<span>{this.state.total_halfday}</span></p>
						<p class="atn-label bg-white absent-color">Absent<span>{this.state.total_absent}</span></p>
						<p class="atn-label  bg-white leave-color br-right10">Leave<span>{this.state.total_leave}</span></p>
			   </div>

			   <div class="col-md-12 mb-20 center no-padd attnd">
			   
				</div>
                  <section class="invoice-list-wrapper section food">
					<div class="children bg-blue attendance mh-500 form-group">

						<div class="row">
						   {this.state.school_list.map((list) => (
						   <>
						   <div class="col-md-2 center mb-10 ">
						   <div class="border pt-10">
							
							
						   
						   <label for={list.id} class="iq-card w-m checked ">
						   <div class="center">
						    
						   {(() => {

								if (list.image !='') {
								return (
										<img src={list.image} class="atd-img" /> 
									   )
								}else{
								return (
										<img src={person} class="atd-img" /> 
									   )
								}
							})()}
						   {list.name} <br/>
						   {list.class_name}
						   
						   </div>
						   {(() => {

								if (list.student_in =='1') {
								return (
										<span class="in-time in-color">Present<br/> In Time : {list.in_time}</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_out =='1') {
								return (<>
										<span class="in-time in-color">In Time : {list.in_time}</span>
										<span class="in-time  out-color">Out Time : {list.out_time}</span>
									   </>)
								}
							})()}
							{(() => {
								if (list.student_halfday == '1') {
								return (
										<span class="in-time halfday-color">Halfday</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_absent =='1') {
								return (
										<span class="in-time absent-color">Absent</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_leave =='1') {
								return (
										<span class="in-time leave-color">Leave</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_unmark =='1') {
								return (
										<span class="in-time unmark-color">Unmark</span>
									   )
								}
							})()}

							
						   </label>
						   
							
							</div>
							</div>
							</>
						   ))}
						
						</div>   

						   {(() => {
								if (student_lenght == 0) {
								return (
										<h6 class="center">No Staff Found</h6>
									   )
								}
							})()}





					</div>

                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
        </div>




         </div>
      </div>

			</div>
		)
	}
}
export default Index;
